import React from "react";
import { BookingLogsModel } from "app/models";
import styles from './styles.module.scss';
import { getInvitationGroupTitle } from "app/components/helpers/getInvitationGroupTitle";
import SingleBookingLog from "../SingleBookingLog";

interface BookingLogGroupProps {
  groupKey: TimeRangeEnum;
  logs: BookingLogsModel[];
  isCoach: boolean;
  t: (key: string) => string;
}

enum TimeRangeEnum {
  Today = "today",
  ThisWeek = "thisWeek",
  ThisMonth = "thisMonth",
  EverythingElse = "everythingElse",
}

const BookingLogGroup = ({ groupKey, logs, isCoach, t }: BookingLogGroupProps) => {
  if (logs.length === 0) {
    return null;
  }

  return (
    <div key={groupKey} className={styles.logs_list}>
      <label>
        {getInvitationGroupTitle(groupKey, t)}
      </label>
      {logs.map((bookingLog: BookingLogsModel) => (
        <div key={bookingLog.id}>
          <SingleBookingLog bookingLog={bookingLog} isCoach={isCoach} />
        </div>
      ))}
    </div>
  );
};

export default BookingLogGroup;
